module.exports = __webpack_public_path__ + "img/motion-design-fous-terroir.022266a.jpg";